import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { PageAbsolutePath } from '../../../consts/Common';
import RenewalsPageInfo from './RenewalsPageInfo';
import { JourneyState } from '../../common/CommonTypes';

type PageInfoProps = {
  renewalsJourney: JourneyState;
  currentPath: string;
  setExpandedDocIds: (docIds: string[]) => void;
};

const RenewalsMobileInfoBar = ({
  renewalsJourney,
  currentPath,
  setExpandedDocIds
}: PageInfoProps): JSX.Element => {
  const [expanded, setExpanded] = useState<boolean>(true);

  const handleChange = () => setExpanded(!expanded);

  const getPanelHeading = () => {
    switch (currentPath) {
      case PageAbsolutePath.Renewals.PersonalDetails:
      case PageAbsolutePath.Renewals.VehicleDetails:
      case PageAbsolutePath.Renewals.Quote:
      case PageAbsolutePath.Renewals.Summary:
      case PageAbsolutePath.Renewals.DirectDebit:
      case PageAbsolutePath.Renewals.SinglePayment:
        return 'More information';
      default:
        return '';
    }
  };

  const getAccordionContent = () => {
    switch (currentPath) {
      case PageAbsolutePath.Renewals.PersonalDetails:
      case PageAbsolutePath.Renewals.VehicleDetails:
      case PageAbsolutePath.Renewals.Quote:
      case PageAbsolutePath.Renewals.Summary:
      case PageAbsolutePath.Renewals.DirectDebit:
      case PageAbsolutePath.Renewals.SinglePayment:
        return (
          <RenewalsPageInfo
            currentPath={currentPath}
            renewalsJourney={renewalsJourney}
            setExpandedDocIds={setExpandedDocIds}
          />
        );
      default:
        return '';
    }
  };

  const mobileInfo = () => {
    switch (currentPath) {
      case PageAbsolutePath.Renewals.PersonalDetails:
      case PageAbsolutePath.Renewals.VehicleDetails:
      case PageAbsolutePath.Renewals.Quote:
      case PageAbsolutePath.Renewals.Summary:
      case PageAbsolutePath.Renewals.DirectDebit:
      case PageAbsolutePath.Renewals.SinglePayment:
        return (
          <div
            className='desktop-hide'
            style={{
              boxShadow: '0px -1px 0px #eeeeee',
              paddingTop: '30px',
              marginTop: '30px',
              fontSize: '22px'
            }}>
            <Accordion expanded={expanded} onChange={handleChange}>
              <AccordionSummary
                id='mobile-more-information'
                expandIcon={
                  <span style={{ float: 'right' }}>
                    <ExpandLessIcon />
                  </span>
                }>
                <span>{getPanelHeading()}</span>
              </AccordionSummary>
              <AccordionDetails>
                {
                  <div className='mobile-content-info page-info-container'>
                    {getAccordionContent()}
                  </div>
                }
              </AccordionDetails>
            </Accordion>
          </div>
        );
      default:
        return '';
    }
  };

  return <div>{mobileInfo()}</div>;
};

export default RenewalsMobileInfoBar;
